import { Context } from "effect";
import type { Effect, Scope } from "effect";
import type { Atom, AsyncResult } from "effect/unstable/reactivity";
import type { ResourceFailure } from "@workerstation/shared/errors/resource";
import type { ContainerSnapshot, ContainerTarget } from "../../api/containers/model.ts";
import type { CatalogSession } from "../catalog/model.ts";
import type { ContainerExplorerAction, ContainerMutationSnapshot, ContainerSettlement } from "./model.ts";

export class ContainerBrowserIo extends Context.Service<ContainerBrowserIo, {
  readonly confirmDestroy: (target: ContainerTarget) => Effect.Effect<boolean, ResourceFailure>;
}>()("workerstation/frontend/ContainerBrowserIo") {}
export interface ContainerSession {
  readonly catalog: Pick<CatalogSession<ContainerSnapshot>, "snapshot" | "read">;
  readonly mutation: Atom.Atom<AsyncResult.AsyncResult<ContainerMutationSnapshot>>;
  readonly settlements: Effect.Effect<readonly ContainerSettlement[]>;
  readonly dispatch: (action: ContainerExplorerAction) => Effect.Effect<void>;
}
export class ContainerSessions extends Context.Service<ContainerSessions, {
  readonly open: Effect.Effect<ContainerSession, never, Scope.Scope>;
  readonly pending: Atom.Atom<AsyncResult.AsyncResult<readonly string[]>>;
}>()("workerstation/frontend/ContainerSessions") {}
